import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const navLinks = [
    { label: 'Accueil', href: '/' },
    { label: 'Services', href: '/#services' },
    { label: 'À propos', href: '/#about' },
    { label: 'Tarifs', href: '/#tarifs' },
    { label: 'Blog', href: '/blog' }
  ];

  const handleNavClick = (e, href) => {
    if (href === '/') {
      e.preventDefault();
      navigate('/');
      window.scrollTo(0, 0);
    } else if (href === '/contact') {
      e.preventDefault();
      navigate('/contact');
      window.scrollTo(0, 0);
    } else if (href.startsWith('/#')) {
      e.preventDefault();
      const id = href.substring(2);
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" onClick={() => window.scrollTo(0, 0)}>
            <img
              src="/images/logo-lynko-header.png"
              alt="LYNKO - Connecter, Installer, Accompagner"
              className="h-9 lg:h-11 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="text-gray-600 hover:text-blue-500 font-medium transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button 
              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-5 py-2.5 rounded-lg transition-all duration-200"
              onClick={() => { navigate('/contact'); window.scrollTo(0, 0); }}
            >
              Demander un devis / Contact
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-gray-600"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-gray-600 hover:text-blue-500 font-medium transition-colors"
                >
                  {link.label}
                </a>
              ))}
              <Button 
                className="bg-blue-500 hover:bg-blue-600 text-white font-semibold w-full mt-2"
                onClick={() => { navigate('/contact'); window.scrollTo(0, 0); setIsMenuOpen(false); }}
              >
                Demander un devis / Contact
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
